/**
 * SupplierJourneyObservability (AJIP-16.02.008 · WS17)
 * ---------------------------------------------------------------------
 * 18 internal event kinds. Same handler pattern as buyer/core layers.
 * Event names are `SUPPLIER_JOURNEY_*` prefixed (P2-03 applied
 * prospectively) so the internal observability namespace is stable
 * across every Adaptive Journey package.
 */

const SUPPLIER_JOURNEY_EVENTS = Object.freeze({
  SUPPLIER_JOURNEY_REGISTRATION_CONFIRMED: 'SUPPLIER_JOURNEY_REGISTRATION_CONFIRMED',
  SUPPLIER_JOURNEY_DISCOVERY_REQUESTED: 'SUPPLIER_JOURNEY_DISCOVERY_REQUESTED',
  SUPPLIER_JOURNEY_ELIGIBILITY_EVALUATED: 'SUPPLIER_JOURNEY_ELIGIBILITY_EVALUATED',
  SUPPLIER_JOURNEY_OWNERSHIP_EVALUATED: 'SUPPLIER_JOURNEY_OWNERSHIP_EVALUATED',
  SUPPLIER_JOURNEY_RESOLUTION_REQUESTED: 'SUPPLIER_JOURNEY_RESOLUTION_REQUESTED',
  SUPPLIER_JOURNEY_RESOLUTION_COMPLETED: 'SUPPLIER_JOURNEY_RESOLUTION_COMPLETED',
  SUPPLIER_JOURNEY_ACTIVATION_REQUESTED: 'SUPPLIER_JOURNEY_ACTIVATION_REQUESTED',
  SUPPLIER_JOURNEY_ACTIVATED: 'SUPPLIER_JOURNEY_ACTIVATED',
  SUPPLIER_JOURNEY_ACTIVATION_REJECTED: 'SUPPLIER_JOURNEY_ACTIVATION_REJECTED',
  SUPPLIER_JOURNEY_STAGE_TRANSITIONED: 'SUPPLIER_JOURNEY_STAGE_TRANSITIONED',
  SUPPLIER_JOURNEY_PAUSED: 'SUPPLIER_JOURNEY_PAUSED',
  SUPPLIER_JOURNEY_RESUMED: 'SUPPLIER_JOURNEY_RESUMED',
  SUPPLIER_JOURNEY_PERSISTED: 'SUPPLIER_JOURNEY_PERSISTED',
  SUPPLIER_JOURNEY_RESTORATION_REQUESTED: 'SUPPLIER_JOURNEY_RESTORATION_REQUESTED',
  SUPPLIER_JOURNEY_RESTORED: 'SUPPLIER_JOURNEY_RESTORED',
  SUPPLIER_JOURNEY_BLOCKED: 'SUPPLIER_JOURNEY_BLOCKED',
  SUPPLIER_JOURNEY_CANCELLED: 'SUPPLIER_JOURNEY_CANCELLED',
  SUPPLIER_JOURNEY_FAILED: 'SUPPLIER_JOURNEY_FAILED',
  SUPPLIER_JOURNEY_COMPLETED: 'SUPPLIER_JOURNEY_COMPLETED',
});
const ALL_SUPPLIER_JOURNEY_EVENTS = Object.freeze(Object.values(SUPPLIER_JOURNEY_EVENTS));

class SupplierJourneyObservability {
  constructor() {
    this._handlers = new Map();
    for (const k of ALL_SUPPLIER_JOURNEY_EVENTS) this._handlers.set(k, new Set());
    this._enabled = true;
  }
  on(kind, handler) {
    if (!ALL_SUPPLIER_JOURNEY_EVENTS.includes(kind) || typeof handler !== 'function') return () => {};
    this._handlers.get(kind).add(handler);
    return () => this._handlers.get(kind).delete(handler);
  }
  emit(kind, payload) {
    if (!this._enabled || !ALL_SUPPLIER_JOURNEY_EVENTS.includes(kind)) return 0;
    let count = 0;
    for (const h of this._handlers.get(kind)) {
      try { h(Object.freeze({ event: kind, at: Date.now(), payload })); count += 1; } catch (_e) { /* isolate */ }
    }
    return count;
  }
  listenerCount(kind) { return this._handlers.has(kind) ? this._handlers.get(kind).size : 0; }
}

export {
  SUPPLIER_JOURNEY_EVENTS,
  ALL_SUPPLIER_JOURNEY_EVENTS,
  SupplierJourneyObservability,
};
